/**
 * LifterLMS Stripe JS payment gateway
 *
 * @package LifterLMS_Stripe/Scripts
 *
 * @since 4.0.0
 * @version 5.0.0
 */

/**
 * Stripe Payment gateway JS
 *
 * @since 4.0.0
 * @since 4.3.2 Unknown.
 * @since 5.0.0 Handle 3DS/SCA authorizations.
 */
( function( $ ) {

	var llms_stripe = window.llms_stripe || {},
		customer    = llms_stripe.customer || {},
		stripe      = Stripe( llms_stripe.publishable_key ),
		elements    = stripe.elements( llms_stripe.settings.elements ),
		card        = elements.create( 'card', llms_stripe.settings.card );

	llms_stripe.customer = {};

	/**
	 * Bind DOM events
	 *
	 * @since 4.0.0
	 * @since 4.3.2 Unknown.
	 * @since 5.0.0 Handle 3DS/SCA authorizations.
	 */
	llms_stripe.bind = function() {

		var self = this;

		// add token creation & cc validation to core before submit validations.
		window.llms.checkout.add_before_submit_event( {
			data: self,
			handler: self.submit,
		} );

		if ( $( '#llms-stripe-card-element' ).length ) {

			self.mount_card();

		}

		// saved card dropdown interactions.
		$( '#llms_stripe_saved_card_id' ).on( 'change', function() {

			var card_id  = $( this ).val(),
				$card_id = $( '#llms_stripe_card_id' );

			// remove the existing card ID (if there is one) & mount the Stripe Element.
			if ( 'create-new' === card_id ) {

				$card_id.val( '' );
				card.mount( '#llms-stripe-card-element' );
				self.toggle_submit( false );

				// unmount the element and set the card ID to be the selected card ID.
			} else {

				$card_id.val( card_id );
				card.unmount();
				self.toggle_submit( true );

			}

		} );

		$( '#llms_billing_zip' ).on( 'blur', function() {

			card.update( {
				value: {
					postalCode: $( '#llms_billing_zip' ).val(),
				},
			} );

		} ).trigger( 'blur' );

		// trigger saved card field change on pageload.
		$( '#llms_stripe_saved_card_id' ).trigger( 'change' );

		// when stripe is selected we should trigger a saved card change.
		$( '.llms-payment-gateways' ).on( 'llms-gateway-selected', function( e, data ) {
			if ( 'stripe' === data.id ) {

				if ( card._complete ) {
					self.toggle_submit( true );
				} else {
					self.toggle_submit( false );
				}

				$( '#llms_stripe_saved_card_id' ).trigger( 'change' );

				if ( 'create-new' !== $( '#llms_stripe_saved_card_id' ).val() ) {
					card.focus();
				}

			}
		} );

		if ( llms.checkout.$confirm_form.length && 'stripe' === $( '#llms-payment-gateway' ).val() ) {

			llms.checkout.processing( 'start' );

			// On the order confirmation screen this hidden field will be a redirect URL.
			var $intent_cs = $( '#llms-stripe-intent-cs' );
			if ( $intent_cs.length ) {
				self.bind_confirmation( $intent_cs.val() );
			} else {
				llms.checkout.$confirm_form.submit();
			}

		}

	};

	/**
	 * Handle SCA/3DS authorization.
	 *
	 * @since 5.0.0
	 *
	 * @param {string} intent_cs Payment Intent client secret key.
	 */
	llms_stripe.bind_confirmation = function( intent_cs ) {

		var func;
		if ( 0 === intent_cs.indexOf( 'pi_' ) ) {
			func = 'handleCardPayment';
		} else if ( 0 === intent_cs.indexOf( 'seti_' ) ) {
			func = 'handleCardSetup';
		}

		stripe[ func ]( intent_cs ).then( function() {

			llms.checkout.$confirm_form.submit();

		} );

	};

	/**
	 * Mount the card
	 *
	 * @since 4.3.2
	 */
	llms_stripe.mount_card = function() {

		// Add an instance of the card UI component into the `card-element` <div>.
		card.mount( '#llms-stripe-card-element' );

		// do stuff when the card is updated.
		card.addEventListener( 'change', function( event ) {

			// show error messages when an error exists.
			if ( event.error ) {

				llms_stripe.set_error( event.error.message );

				// clear error messages.
			} else {

				llms_stripe.set_error( '' );

			}

			// enable the checkout button.
			if ( event.complete ) {
				llms_stripe.toggle_submit( true );
			} else {
				llms_stripe.toggle_submit( false );
			}

		} );

	};

	/**
	 * Enable/Disable the checkout/update submit button
	 *
	 * @since  4.3.0
	 *
	 * @param {boolean}  toggle  if truthie enables, if falsie, disables.
	 */
	llms_stripe.toggle_submit = function( toggle ) {

		var $btns = $( '#llms_create_pending_order, #llms_save_payment_method' );

		if ( toggle ) {
			$btns.removeAttr( 'disabled' );
		} else {
			$btns.attr( 'disabled', 'disabled' );
		}

	};

	/**
	 * Retrieve an object of customer information to pass to Stripe when creating a token
	 *
	 * @since 4.3.3
	 *
	 * @return {obj} Customer information.
	 */
	llms_stripe.get_customer_data = function() {

		var params = {
				name: [ '#first_name', '#last_name' ],
				address_line1: '#llms_billing_address_1',
				address_line2: '#llms_billing_address_2',
				address_city: '#llms_billing_city',
				address_state: '#llms_billing_state',
				address_zip: '#llms_billing_zip',
				address_country: '#llms_billing_country',
			},
			obj    = customer,
			key;

		for ( key in params ) {

			if ( ! params.hasOwnProperty( key ) ) {
				continue;
			}

			var type = typeof params[ key ],
				str  = '';

			if ( 'string' === type ) {

				str = get_field_val( params[ key ] );

			} else if ( 'object' === type ) {

				var len = type.length;
				for ( var i = 0; i <= len; i++ ) {
					var val = get_field_val( params[ key ][ i ] );
					if ( false !== val ) {
						str += ' ' + val;
					}
				}
				str.trim();

			}

			if ( false !== str && str ) {

				obj[ key ] = str.trim();

			}

		}

		return obj;

	};

	/**
	 * Retrieve field data by selector
	 *
	 * @since    4.3.3
	 *
	 * @param {string} selector  jQuery selector.
	 * @return {string|false} Field value or false.
	 */
	var get_field_val = function( selector ) {

		var $field = $( selector );
		if ( $field.length && $field.val() ) {

			return $field.val().trim();

		}

		return false;

	};

	/**
	 * Retrieve a token using Stripe.js (ASYNC)
	 *
	 * @since 3.0.0
	 * @since 4.3.3 Unknown.
	 *
	 * @param {function}  callback callback function which 2 params: success object & error object.
	 */
	llms_stripe.get_token = function( callback ) {

		stripe.createToken( card, this.get_customer_data() ).then( function( result ) {

			// show error.
			if ( result.error ) {

				callback( null, result.error );

				// add the token to the dom.
			} else {

				callback( result.token );

			}

		} );

	};

	/**
	 * Determine if Stripe is selected on the list of available payment methods
	 *
	 * @since  2.0.0
	 * @since 4.0.0 Unknown
	 *
	 * @return {boolean} true if Stripe is selected, false otherwise.
	 */
	llms_stripe.is_selected = function() {

		// check the payment method radio element to see if it's checked.
		return $( '#llms_payment_gateway_stripe' ).is( ':checked' );

	};

	/**
	 * Add a Stripe Eleents error message
	 *
	 * @since 4.3.0
	 *
	 * @param {string} msg error message.
	 */
	llms_stripe.set_error = function( msg ) {

		var el         = document.getElementById( 'llms-stripe-card-errors' );
		el.textContent = msg;

	};

	/**
	 * Handle checkout submission to retrieve a token when Stripe is the selected gateway
	 *
	 * @since 4.0.0
	 * @since 4.3.0 Unknown.
	 * @since 5.0.0 Remove unused declaration for `$form` var.
	 *
	 * @param {llms_stripe} self LifterLMS Stripe js object.
	 * @param {func} callback Callback function.
	 */
	llms_stripe.submit = function( self, callback ) {

		var $saved   = $( '#llms_stripe_saved_card_id' ),
			response = true;

		// don't proceed unless stripe is selected.
		if ( ! self.is_selected() ) {
			callback( response );
			return;
		}

		// skip if we're using a saved Card ID.
		if ( $saved.length && 'create-new' !== $saved.val() ) {
			callback( response );
			return;
		}

		// get a token.
		llms_stripe.get_token( function( token, err ) {

			// error.
			if ( ! token ) {

				response = err.message;

				// success.
			} else if ( token ) {

				$( '#llms_stripe_token' ).val( token.id );
				$( '#llms_stripe_card_id' ).val( token.card.id );

			}

			callback( response );

		} );

	};

	// add this object to the core checkout class for future binds.
	window.llms.checkout.add_gateway( llms_stripe );

	llms_stripe.bind();

}( jQuery ) );
